import { useSessionMessageApi } from '../../../../utils/actionableNotifications';
import React, { useEffect, useState } from "react";
import { Alert, Button, Space } from 'antd';
import { businessSendInFlight, loadBusinessSend, startNewBusinessSend } from "../../models/shared/businessSendAttempt";

export function BusinessSendRecovery({ actor, query, action }) {
  const message = useSessionMessageApi();
  const [attempt, setAttempt] = useState(null);
  useEffect(() => {
    const read = () => setAttempt(loadBusinessSend(actor, query, action));
    read();
    window.addEventListener("business-send-updated", read);
    window.addEventListener("storage", read);
    return () => { window.removeEventListener("business-send-updated", read); window.removeEventListener("storage", read); };
  }, [actor, query, action]);
  if (!attempt || businessSendInFlight(actor, query, action)) return null;
  const resolved = attempt.state === 'verified_resolved';
  return <Alert showIcon type={attempt.state === "completed" || resolved ? "info" : "warning"}
    message={resolved ? `Verified ${attempt.resolution.resolution.outcome.replace('_', ' ')}` : attempt.state === "completed" ? "This send is already recorded" : "An existing send must be reconciled"}
    description={<Space direction="vertical">
      <span>{attempt.error || "The original request and key are retained across reloads. Provider acceptance is not delivery confirmation."}</span>
      {attempt.body?.message_text && <span style={{ whiteSpace: "pre-wrap", maxHeight: 80, overflowY: "auto" }}>Frozen message: {attempt.body.message_text}</span>}
      {attempt.state === "completed" || resolved ? <Button size="small" onClick={() => {
        try { startNewBusinessSend(actor, query, action); } catch (error) { message.error(error.message); }
      }}>Start a new intentional send</Button> : <span>Outcome verification is required. Replay is blocked because a backend gate rollback could bypass deduplication. The original request and key remain saved.</span>}
    </Space>} />;
}
